export default __webpack_public_path__ + "static/media/ZW.7fa0de6d.svg";